// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
  --background: white !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding-inline: 7px;
  cursor: pointer;
  border-radius: 22px;
  background-color: #fff;
  padding: 10px;
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.add-more .add-button {
  margin-right: 12px;
}

.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-button.invalid {
  --background: darkgrey;
  color: grey;
}

.wrapper {
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
  background: black url('background.png') no-repeat center center/100% 100% !important;
  background-size: cover;
}

.order-list {
  margin-block: 12px;
  width: 100%;
}
@media (min-width: 400px) {
  .order-list {
    max-height: 260px;
    overflow: auto;
  }
}

.promo-code {
  width: 100%;
  margin-block: 12.5px;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.ordered-articles {
  flex: 1;
  overflow: auto;
  padding: 16px 17px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
  padding: 18px 13px;
  margin-bottom: 13px;
}

.title {
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  text-align: center;
  color: #000;
  margin-bottom: 18px;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.total .total-title {
  font-family: AppFontBold;
  font-size: 14px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.total .total-sum {
  font-family: AppFontBold;
  font-size: 13px;
  text-align: right;
  color: #000;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.add-to-order-button {
  margin: 4px 12px 12px 12px;
}

app-payment-methods-display {
  margin: 0 12px;
  display: block;
}

.from-menu .title {
  color: var(--ion-color-dark);
}

.points {
  padding: 9px 18px;
  width: 100%;
  margin-bottom: 12px;
}
.points_info {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 12px;
}
.points_info .info_section {
  display: flex;
  align-items: flex-start;
}
.points_info .info_section .points_text {
  margin-left: 10px;
}
.points_info ion-img {
  width: 62px;
  height: 20px;
}
.points .img-info {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: #000000;
  text-transform: capitalize;
}
.points_text {
  display: flex;
  flex-direction: column;
  width: 54%;
}
.points_title {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 15px;
  text-align: left;
  color: #000000;
}
.points_description {
  font-family: AppFont;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
  color: #000000;
  margin-top: 5px;
}
.points_current {
  height: 45px;
  width: 45px;
  border: 4px dotted black;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.points_quantity {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: #000;
}
.points .buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.points .buttons_button {
  width: 100%;
  height: 30px;
  background-color: var(--ion-color-primary);
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #fff;
}
.points .buttons_button:last-child {
  background-color: transparent;
  color: var(--ion-color-primary);
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 17px;
  background: white;
}
.footer__select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.footer__select-info {
  width: 45%;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  color: #000;
}
.footer ion-radio-group {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.footer ion-radio-group ion-radio {
  --border-width: 1px;
  --border-color: #000;
  --border-color-checked: #000;
  --background-checked: transparent;
  --color-checked: #000;
  --color: #000;
}
.footer ion-radio-group .radio-checked::part(mark) {
  transform: scale3d(1.4, 1.4, 1);
}
.footer .button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.footer .button-row .footer-btn {
  margin-top: 12px;
  min-height: 46px;
  height: 46px;
  width: 75%;
  position: relative;
  --padding-start: 5px;
  --padding-end: 5px;
  --padding-top: 5px;
  --padding-bottom: 5px;
}
.footer .button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  color: #fff;
  margin: 0 auto;
}
.footer .button-row .footer-btn .button-img {
  width: 35px;
  height: 35px;
  margin-left: 5px;
}
.footer .button-row .button-total {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: min-content;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #000;
  text-transform: uppercase;
  margin-left: auto;
}
.footer .button-row .button-total span {
  font-family: AppFontBold;
  font-size: 18px;
  color: #000;
}

.no-articles {
  display: flex;
}
.no-articles ion-icon {
  color: white;
  fill: white;
  margin-right: 10px;
  display: none;
}
@media (min-width: 991px) {
  .no-articles ion-icon {
    fill: black;
    color: black;
  }
}
@media (min-width: 991px) {
  .no-articles ion-icon.big-screen {
    display: block;
  }
}
@media (max-width: 992px) {
  .no-articles ion-icon.small-screen {
    display: block;
  }
}
.no-articles h3 {
  color: white;
}

.age-verified {
  color: var(--ion-color-primary);
  margin-bottom: 10px;
  background: #ffffff;
  max-width: 400px;
}
.age-verified ion-item {
  border: none;
  align-items: flex-start;
}
.age-verified ion-item label {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
}

.error-message {
  color: var(--ion-color-primary);
  text-align: center;
  padding: 20px;
}

.delivery {
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  color: black !important;
}
.delivery span {
  color: black;
  font-family: AppFontBold;
  font-size: 14px;
}

.recommenation_section {
  padding: 20px 17px;
  margin: 10px 0px 0px;
  background: transparent;
  box-shadow: none;
}
@media (min-width: 991px) {
  .recommenation_section {
    padding: 12px 17px;
    margin: 8px 0px 0px;
  }
}
.recommenation_section .recom_title {
  color: white;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
  margin: 0 0 20px 0;
  text-align: left;
}
@media (min-width: 991px) {
  .recommenation_section .recom_title {
    font-size: 16px;
    margin: 0 0 12px 0;
  }
}
.recommenation_section .recommenation_section_articles__item {
  display: flex;
  padding: 15px;
  flex-direction: column;
  position: relative;
  min-height: 200px;
  border-radius: 0;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
  background: white;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;
}
@media (min-width: 991px) {
  .recommenation_section .recommenation_section_articles__item {
    padding: 10px;
    min-height: 140px;
  }
}
.recommenation_section .recommenation_section_articles__item:hover {
  transform: translateY(-2px);
  box-shadow: 0px 8px 25px 0px rgba(0, 0, 0, 0.15);
}
.recommenation_section .recommenation_section_articles__item img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  margin: 0 auto 12px auto;
  display: block;
}
@media (min-width: 991px) {
  .recommenation_section .recommenation_section_articles__item img {
    height: 50px;
    margin: 0 auto 8px auto;
  }
}
.recommenation_section .recommenation_section_articles__item div {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.recommenation_section .recommenation_section_articles__item div .left-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.recommenation_section .recommenation_section_articles__item div h3 {
  color: #000;
  font-size: 14px;
  text-align: center;
  padding: 0;
  margin: 0 0 12px 0;
  font-family: AppFontBold, sans-serif;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: auto;
  min-height: 35px;
  width: 100%;
  line-height: 1.3;
}
@media (min-width: 991px) {
  .recommenation_section .recommenation_section_articles__item div h3 {
    font-size: 12px;
    margin: 0 0 8px 0;
    min-height: 28px;
    line-height: 1.2;
  }
}
.recommenation_section .recommenation_section_articles__item div .price_pfand_block {
  width: 40%;
}
.recommenation_section .recommenation_section_articles__item div .rec-price {
  align-self: flex-start;
}
.recommenation_section .recommenation_section_articles__item .add_button {
  width: 80%;
  margin: 0 auto;
  border: 1px solid var(--ion-color-primary);
  background: var(--ion-color-primary);
  padding: 8px 12px;
  border-radius: 20px;
  color: white;
  font-family: AppFontBold;
  text-align: center;
  display: flex;
  justify-content: center;
  font-size: 12px;
  text-transform: uppercase;
  transition: all 0.3s ease;
}
@media (min-width: 991px) {
  .recommenation_section .recommenation_section_articles__item .add_button {
    padding: 6px 10px;
    font-size: 10px;
    border-radius: 15px;
  }
}
.recommenation_section .recommenation_section_articles__item .add_button:hover {
  background: #8b0000;
  border-color: #8b0000;
}
.recommenation_section .recommenation_section_articles__item .price {
  text-align: center;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  color: #000;
  margin: 8px 0 0 0;
  font-weight: bold;
}
@media (min-width: 991px) {
  .recommenation_section .recommenation_section_articles__item .price {
    font-size: 14px;
    margin: 6px 0 0 0;
  }
}

swiper-container {
  height: 100%;
  transition-timing-function: linear;
  padding-bottom: 10px;
}
swiper-container swiper-slide {
  margin: 0;
  height: auto;
}

.checkbox {
  display: flex;
  justify-content: space-between;
}
.checkbox ion-checkbox {
  --border-width: 1px;
  --checkbox-background-checked: var(--ion-color-dark);
  --border-color-checked: var(--ion-color-dark);
  margin: 15px 0 !important;
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
}
.checkbox ion-checkbox::part(container) {
  width: 20px;
  height: 20px;
}
.checkbox ion-checkbox::part(mark) {
  transform: scale(0.7) translate(19%, 19%);
}

.relevo-section {
  width: 100%;
  margin-block: 12.5px;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
  background: white;
  padding: 18px 13px;
}

.relevo-input-section .relevo-input-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  --min-height: 56px;
  margin-bottom: 8px;
}
.relevo-input-section .relevo-input-item .relevo-label {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #000;
  margin-bottom: 8px;
}
.relevo-input-section .relevo-input-item .relevo-input {
  --padding-start: 12px;
  --padding-end: 12px;
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.relevo-input-section .relevo-error {
  margin: 8px 0 0 0;
  font-size: 13px;
  text-align: left;
  color: var(--ion-color-primary);
  padding: 0 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,8BAAA;AADD;;AAIA;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AAND;AAEC;EACC,YAAA;AAAF;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAHD;AAIC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAFF;AAKC;EACC,kBAAA;AAHF;;AAOA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAJD;;AAOA;EACC,sBAAA;EACA,WAAA;AAJD;;AAOA;EACC,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EAEA,oFAAA;EACA,sBAAA;AALD;;AAQA;EACC,kBAAA;EACA,WAAA;AALD;AAMC;EAHD;IAIE,iBAAA;IACA,cAAA;EAHA;AACF;;AAMA;EACC,WAAA;EACA,oBAAA;EACA,wDAAA;AAHD;;AAKA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFD;ACpFE;EDiFF;IAOE,YAAA;EAAA;AACF;;AAGA;EACC,OAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wDAAA;EACA,kBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAAD;;AAGA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAAD;AAEC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AAAF;AAEC;EACC,yBAAA;AAAF;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AADD;AAGC;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AADF;AAGC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AADF;;AAKA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAFD;;AAKA;EACC,0BAAA;AAFD;;AAKA;EACC,cAAA;EACA,cAAA;AAFD;;AAMC;EACC,4BAAA;AAHF;;AAOA;EACC,iBAAA;EACA,WAAA;EACA,mBAAA;AAJD;AAMC;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AAJF;AAKE;EACC,aAAA;EACA,uBAAA;AAHH;AAIG;EACC,iBAAA;AAFJ;AAKE;EACC,WAAA;EACA,YAAA;AAHH;AAOC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AALF;AAQC;EACC,aAAA;EACA,sBAAA;EACA,UAAA;AANF;AASC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAPF;AAUC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AARF;AAWC;EACC,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVF;AAaC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAXF;AAcC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAZF;AAcE;EACC,WAAA;EACA,YAAA;EACA,0CAAA;EACA,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAbH;AAeG;EACC,6BAAA;EACA,+BAAA;AAbJ;;AAmBA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;AAhBD;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAfF;AAkBC;EACC,UAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAhBF;AAmBC;EACC,UAAA;EACA,aAAA;EACA,yBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAlBF;AAmBE;EACC,mBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;AAlBH;AAoBE;EACC,+BAAA;AAlBH;AAsBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AApBF;AAsBE;EACC,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AApBH;AAqBG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAnBJ;AAqBG;EACC,WAAA;EACA,YAAA;EACA,gBAAA;AAnBJ;AAuBE;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;AArBH;AAsBG;EACC,wBAAA;EACA,eAAA;EACA,WAAA;AApBJ;;AA0BA;EACC,aAAA;AAvBD;AAwBC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EAMA,aAAA;AA3BF;ACxXE;ED0YD;IAME,WAAA;IACA,YAAA;EApBD;AACF;AC9XE;EDoZA;IAEE,cAAA;EApBF;AACF;AC7XE;EDmZA;IAEE,cAAA;EApBF;AACF;AAuBC;EACC,YAAA;AArBF;;AAwBA;EACC,+BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AArBD;AAsBC;EACC,YAAA;EACA,uBAAA;AApBF;AAqBE;EACC,oCAAA;EACA,eAAA;AAnBH;;AAwBA;EACC,+BAAA;EACA,kBAAA;EACA,aAAA;AArBD;;AAuBA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;AApBD;AAqBC;EACC,YAAA;EACA,wBAAA;EACA,eAAA;AAnBF;;AAuBA;EACC,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gBAAA;AApBD;ACrbE;EDqcF;IAOE,kBAAA;IACA,mBAAA;EAnBA;AACF;AAqBC;EACC,YAAA;EACA,yBAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAnBF;ACncE;EDgdD;IASE,eAAA;IACA,kBAAA;EAlBD;AACF;AAqBC;EACC,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,+CAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AAnBF;ACtdE;ED8dD;IAcE,aAAA;IACA,iBAAA;EAlBD;AACF;AAoBE;EACC,2BAAA;EACA,gDAAA;AAlBH;AAsBE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AApBH;ACveE;EDsfA;IAQE,YAAA;IACA,uBAAA;EAnBF;AACF;AAqBE;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;AAnBH;AAqBG;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAnBJ;AAqBG;EACC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAnBJ;AC1gBE;ED8gBC;IAkBE,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAlBH;AACF;AAoBG;EACC,UAAA;AAlBJ;AAoBG;EACC,sBAAA;AAlBJ;AAqBE;EACC,UAAA;EACA,cAAA;EACA,0CAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;AAnBH;ACxiBE;ED6iBA;IAiBE,iBAAA;IACA,eAAA;IACA,mBAAA;EAlBF;AACF;AAoBG;EACC,mBAAA;EACA,qBAAA;AAlBJ;AAqBE;EACC,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AAnBH;AC3jBE;EDwkBA;IASE,eAAA;IACA,iBAAA;EAlBF;AACF;;AAsBA;EACC,YAAA;EACA,kCAAA;EACA,oBAAA;AAnBD;AAqBC;EACC,SAAA;EACA,YAAA;AAnBF;;AAsBA;EACC,aAAA;EACA,8BAAA;AAnBD;AAqBC;EACC,mBAAA;EACA,oDAAA;EACA,6CAAA;EACA,yBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;AAnBF;AAqBE;EACC,WAAA;EACA,YAAA;AAnBH;AAsBE;EACC,yCAAA;AApBH;;AA0BA;EACC,WAAA;EACA,oBAAA;EACA,wDAAA;EACA,iBAAA;EACA,kBAAA;AAvBD;;AA2BC;EACC,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAxBF;AA0BE;EACC,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAxBH;AA2BE;EACC,qBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AAzBH;AA6BC;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AA3BF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\tpadding: 0 10px;\n\t--background: white !important;\n}\n\n.promo-info {\n\talign-items: center;\n\tpadding: 10px 17px;\n\tbackground: white;\n\tmargin: 10px 10px 0;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\tdisplay: none;\n}\n\n.min-order {\n\tmargin: 10px 10px 0;\n}\n\n.add-more {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\theight: 34px;\n\tmin-width: fit-content;\n\tpadding-inline: 7px;\n\tcursor: pointer;\n\tborder-radius: 22px;\n\tbackground-color: #fff;\n\tpadding: 10px;\n\t.add-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.add-button {\n\t\tmargin-right: 12px;\n\t}\n}\n\n.card-actions {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.footer-button.invalid {\n\t--background: darkgrey;\n\tcolor: grey;\n}\n\n.wrapper {\n\tmax-height: 100%;\n\tflex-direction: column;\n\tdisplay: flex;\n\theight: 100%;\n\n\tbackground: black url(../../../assets/background/background.png) no-repeat center center / 100% 100% !important;\n\tbackground-size: cover;\n}\n\n.order-list {\n\tmargin-block: 12px;\n\twidth: 100%;\n\t@media (min-width: 400px) {\n\t\tmax-height: 260px;\n\t\toverflow: auto;\n\t}\n}\n\n.promo-code {\n\twidth: 100%;\n\tmargin-block: 12.5px;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n}\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n.ordered-articles {\n\tflex: 1;\n\toverflow: auto;\n\tpadding: 16px 17px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.ordered-articles-container {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tbackground-color: #fff;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\tpadding: 18px 13px;\n\tmargin-bottom: 13px;\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 25px;\n\tline-height: 21px;\n\ttext-align: center;\n\tcolor: #000;\n\tmargin-bottom: 18px;\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n\t&--wide .line {\n\t\tbackground-size: 8px 100%;\n\t}\n}\n\n.total {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\tmargin-top: 19px;\n\n\t.total-title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\t.total-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\ttext-align: right;\n\t\tcolor: #000;\n\t}\n}\n\n.promo-error {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: red;\n\tdisplay: none;\n}\n\n.add-to-order-button {\n\tmargin: 4px 12px 12px 12px;\n}\n\napp-payment-methods-display {\n\tmargin: 0 12px;\n\tdisplay: block;\n}\n\n.from-menu {\n\t.title {\n\t\tcolor: var(--ion-color-dark);\n\t}\n}\n\n.points {\n\tpadding: 9px 18px;\n\twidth: 100%;\n\tmargin-bottom: 12px;\n\n\t&_info {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: stretch;\n\t\tmargin-bottom: 12px;\n\t\t.info_section {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\t.points_text {\n\t\t\t\tmargin-left: 10px;\n\t\t\t}\n\t\t}\n\t\tion-img {\n\t\t\twidth: 62px;\n\t\t\theight: 20px;\n\t\t}\n\t}\n\n\t.img-info {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t\ttext-transform: capitalize;\n\t}\n\n\t&_text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 54%;\n\t}\n\n\t&_title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 18px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t}\n\n\t&_description {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t\tmargin-top: 5px;\n\t}\n\n\t&_current {\n\t\theight: 45px;\n\t\twidth: 45px;\n\t\t// background: url(../../../assets/losteria/doted_circle.png) no-repeat center center/ 100%;\n\t\tborder: 4px dotted black;\n\t\tborder-radius: 50%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&_quantity {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n\n\t.buttons {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tgap: 10px;\n\n\t\t&_button {\n\t\t\twidth: 100%;\n\t\t\theight: 30px;\n\t\t\tbackground-color: var(--ion-color-primary);\n\t\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\t\tborder-radius: 41px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\n\t\t\t&:last-child {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 17px;\n\tbackground: white;\n\t&__select {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&__select-info {\n\t\twidth: 45%;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 12px;\n\t\tline-height: 14px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n\n\tion-radio-group {\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t\tion-radio {\n\t\t\t--border-width: 1px;\n\n\t\t\t--border-color: #000;\n\t\t\t--border-color-checked: #000;\n\t\t\t--background-checked: transparent;\n\t\t\t--color-checked: #000;\n\t\t\t--color: #000;\n\t\t}\n\t\t.radio-checked::part(mark) {\n\t\t\ttransform: scale3d(1.4, 1.4, 1);\n\t\t}\n\t}\n\n\t.button-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\n\t\t.footer-btn {\n\t\t\tmargin-top: 12px;\n\t\t\tmin-height: 46px;\n\t\t\theight: 46px;\n\t\t\twidth: 75%;\n\t\t\tposition: relative;\n\t\t\t--padding-start: 5px;\n\t\t\t--padding-end: 5px;\n\t\t\t--padding-top: 5px;\n\t\t\t--padding-bottom: 5px;\n\t\t\t.footer-btn-text {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 14px;\n\t\t\t\tcolor: #fff;\n\t\t\t\tmargin: 0 auto;\n\t\t\t}\n\t\t\t.button-img {\n\t\t\t\twidth: 35px;\n\t\t\t\theight: 35px;\n\t\t\t\tmargin-left: 5px;\n\t\t\t}\n\t\t}\n\n\t\t.button-total {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tjustify-content: flex-end;\n\t\t\twidth: min-content;\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\t\t\ttext-align: right;\n\t\t\tcolor: #000;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-left: auto;\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: #000;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.no-articles {\n\tdisplay: flex;\n\tion-icon {\n\t\tcolor: white;\n\t\tfill: white;\n\t\tmargin-right: 10px;\n\n\t\t@include desktop {\n\t\t\tfill: black;\n\t\t\tcolor: black;\n\t\t}\n\t\tdisplay: none;\n\t\t&.big-screen {\n\t\t\t@include desktop {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t&.small-screen {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\th3 {\n\t\tcolor: white;\n\t}\n}\n.age-verified {\n\tcolor: var(--ion-color-primary);\n\tmargin-bottom: 10px;\n\tbackground: #ffffff;\n\tmax-width: 400px;\n\tion-item {\n\t\tborder: none;\n\t\talign-items: flex-start;\n\t\tlabel {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}\n\n.error-message {\n\tcolor: var(--ion-color-primary);\n\ttext-align: center;\n\tpadding: 20px;\n}\n.delivery {\n\ttext-align: center;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 10px;\n\tcolor: black !important;\n\tspan {\n\t\tcolor: black;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t}\n}\n\n.recommenation_section {\n\tpadding: 20px 17px;\n\tmargin: 10px 0px 0px;\n\tbackground: transparent;\n\tbox-shadow: none;\n\n\t@include desktop {\n\t\tpadding: 12px 17px;\n\t\tmargin: 8px 0px 0px;\n\t}\n\n\t.recom_title {\n\t\tcolor: white;\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 20px;\n\t\tmargin: 0 0 20px 0;\n\t\ttext-align: left;\n\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tmargin: 0 0 12px 0;\n\t\t}\n\t}\n\n\t.recommenation_section_articles__item {\n\t\tdisplay: flex;\n\t\tpadding: 15px;\n\t\tflex-direction: column;\n\t\tposition: relative;\n\t\tmin-height: 200px;\n\t\tborder-radius: 0;\n\t\tbox-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);\n\t\tbackground: white;\n\t\tborder: none;\n\t\ttransition: all 0.3s ease;\n\t\tcursor: pointer;\n\n\t\t@include desktop {\n\t\t\tpadding: 10px;\n\t\t\tmin-height: 140px;\n\t\t}\n\n\t\t&:hover {\n\t\t\ttransform: translateY(-2px);\n\t\t\tbox-shadow: 0px 8px 25px 0px rgba(0, 0, 0, 0.15);\n\t\t}\n\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 80px;\n\t\t\tobject-fit: cover;\n\t\t\tmargin: 0 auto 12px auto;\n\t\t\tdisplay: block;\n\n\t\t\t@include desktop {\n\t\t\t\theight: 50px;\n\t\t\t\tmargin: 0 auto 8px auto;\n\t\t\t}\n\t\t}\n\t\tdiv {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: flex-start;\n\n\t\t\t.left-section {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tcolor: #000;\n\t\t\t\tfont-size: 14px;\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0 0 12px 0;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tword-break: break-word;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\toverflow: hidden;\n\t\t\t\theight: auto;\n\t\t\t\tmin-height: 35px;\n\t\t\t\twidth: 100%;\n\t\t\t\tline-height: 1.3;\n\n\t\t\t\t@include desktop {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tmargin: 0 0 8px 0;\n\t\t\t\t\tmin-height: 28px;\n\t\t\t\t\tline-height: 1.2;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.price_pfand_block {\n\t\t\t\twidth: 40%;\n\t\t\t}\n\t\t\t.rec-price {\n\t\t\t\talign-self: flex-start;\n\t\t\t}\n\t\t}\n\t\t.add_button {\n\t\t\twidth: 80%;\n\t\t\tmargin: 0 auto;\n\t\t\tborder: 1px solid var(--ion-color-primary);\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tpadding: 8px 12px;\n\t\t\tborder-radius: 20px;\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFontBold;\n\t\t\ttext-align: center;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\tfont-size: 12px;\n\t\t\ttext-transform: uppercase;\n\t\t\ttransition: all 0.3s ease;\n\n\t\t\t@include desktop {\n\t\t\t\tpadding: 6px 10px;\n\t\t\t\tfont-size: 10px;\n\t\t\t\tborder-radius: 15px;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground: #8b0000;\n\t\t\t\tborder-color: #8b0000;\n\t\t\t}\n\t\t}\n\t\t.price {\n\t\t\ttext-align: center;\n\t\t\tfont-size: 16px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: #000;\n\t\t\tmargin: 8px 0 0 0;\n\t\t\tfont-weight: bold;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin: 6px 0 0 0;\n\t\t\t}\n\t\t}\n\t}\n}\nswiper-container {\n\theight: 100%;\n\ttransition-timing-function: linear;\n\tpadding-bottom: 10px;\n\n\tswiper-slide {\n\t\tmargin: 0;\n\t\theight: auto;\n\t}\n}\n.checkbox {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tion-checkbox {\n\t\t--border-width: 1px;\n\t\t--checkbox-background-checked: var(--ion-color-dark);\n\t\t--border-color-checked: var(--ion-color-dark);\n\t\tmargin: 15px 0!important;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 14px;\n\t\ttext-transform: uppercase;\n\n\t\t&::part(container) {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t}\n\n\t\t&::part(mark) {\n\t\t\ttransform: scale(0.7) translate(19%, 19%);\n\t\t}\n\t}\n}\n\n// Relevo Code Section Styles\n.relevo-section {\n\twidth: 100%;\n\tmargin-block: 12.5px;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\tbackground: white;\n\tpadding: 18px 13px;\n}\n\n.relevo-input-section {\n\t.relevo-input-item {\n\t\t--padding-start: 0;\n\t\t--inner-padding-end: 0;\n\t\t--min-height: 56px;\n\t\tmargin-bottom: 8px;\n\n\t\t.relevo-label {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 1.4;\n\t\t\tcolor: #000;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\n\t\t.relevo-input {\n\t\t\t--padding-start: 12px;\n\t\t\t--padding-end: 12px;\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #000;\n\t\t\ttext-transform: uppercase;\n\t\t\tletter-spacing: 2px;\n\t\t}\n\t}\n\n\t.relevo-error {\n\t\tmargin: 8px 0 0 0;\n\t\tfont-size: 13px;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary);\n\t\tpadding: 0 12px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
